export default "__VITE_ASSET__Bo0FX3Ut__"